import React, { useState } from 'react';
import { createKindBadge } from '../styles/registryStyles';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const RegistryCard = ({ entry, kinds, theme, styles, onClick, onDelete, onDrillInto }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const kindBadge = createKindBadge(entry.kind_slug, kinds, theme);
  const kindName = kinds?.find(k => k.slug === entry.kind_slug)?.name || entry.kind_slug || 'Запись';
  const tagNames = (entry.tags || []).map(t => t.name || t).filter(Boolean);
  const hasChildren = (entry.children_count || 0) > 0;

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setDialogOpen(true);
  };

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onDelete(entry.id);
      setDialogOpen(false);
    } catch (err) {
      console.error('Ошибка удаления:', err);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <div
        style={{ ...styles.card, position: 'relative' }}
        onClick={onClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = styles.cardHover.background;
          e.currentTarget.style.borderColor = styles.cardHover.borderColor;
          e.currentTarget.style.transform = styles.cardHover.transform;
          e.currentTarget.style.boxShadow = styles.cardHover.boxShadow;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = styles.card.background;
          e.currentTarget.style.borderColor = styles.card.borderColor;
          e.currentTarget.style.transform = 'none';
          e.currentTarget.style.boxShadow = styles.card.boxShadow || 'none';
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, paddingRight: 52 }}>
          {entry.kind_slug && (
            <span style={kindBadge}>{kindName}</span>
          )}
          {entry.status && (
            <span style={{
              fontSize: 11,
              padding: '1px 6px',
              borderRadius: 4,
              background: entry.status === 'active'
                ? (theme.name === 'dark' ? '#1e4d2b' : '#d1fae5')
                : (theme.name === 'dark' ? '#3b2f1e' : '#fef3c7'),
              color: entry.status === 'active'
                ? (theme.name === 'dark' ? '#4ade80' : '#065f46')
                : (theme.name === 'dark' ? '#fbbf24' : '#92400e'),
            }}>
              {entry.status}
            </span>
          )}
        </div>

        <div style={styles.name}>
          {entry.name} <span style={{ opacity: 0.65, fontWeight: 400 }}>({entry.code})</span>
        </div>

        {entry.attributes?.owner && (
          <div style={styles.meta}>Владелец: {entry.attributes.owner}</div>
        )}
        {entry.attributes?.domain && (
          <div style={styles.meta}>Домен: {entry.attributes.domain}</div>
        )}

        {entry.updated_at && (
          <div style={styles.meta}>
            Обновлено: {new Date(entry.updated_at).toLocaleString()}
          </div>
        )}

        {entry.description && (
          <div style={{ color: theme.toolbar.text, fontSize: 13 }}>
            {entry.description}
          </div>
        )}

        {tagNames.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 2 }}>
            {tagNames.map(tag => (
              <span key={tag} style={{
                fontSize: 11,
                padding: '2px 8px',
                borderRadius: 8,
                border: styles.card.border,
                color: theme.toolbar.text,
                opacity: 0.8
              }}>
                {tag}
              </span>
            ))}
          </div>
        )}

        {hasChildren && (
          <div style={{ fontSize: 11, opacity: 0.8, marginTop: 4 }}>
            Дочерних: {entry.children_count}
          </div>
        )}

        <div style={{ position: 'absolute', top: 4, right: 4, display: 'flex', gap: 2 }}>
          {hasChildren && onDrillInto && (
            <IconButton
              size="small"
              title="Открыть дочерние"
              onClick={(e) => { e.stopPropagation(); onDrillInto(entry); }}
              style={{ color: theme.toolbar.text }}
            >
              <ChevronRightIcon fontSize="small" />
            </IconButton>
          )}
          {onDelete && (
            <IconButton
              size="small"
              onClick={handleDeleteClick}
              title="Удалить"
              style={{ color: '#ef4444' }}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      </div>

      {dialogOpen && (
        <Dialog open={dialogOpen} onClose={() => !deleting && setDialogOpen(false)}>
          <DialogTitle>Удалить запись?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              «{entry.name}» будет удалена навсегда. Это действие нельзя отменить.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDialogOpen(false)} disabled={deleting}>Отмена</Button>
            <Button onClick={handleConfirm} color="error" disabled={deleting} autoFocus>
              {deleting ? 'Удаление…' : 'Удалить'}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default RegistryCard;
